import ReactDOM from 'react-dom/client';
import App from './App';
import './styles/main.scss';
import "@webcore/utilities/Extensions.ts";
import { appConfig } from "@webcore/config/appConfig.ts";
import Log from "@webcore/services/log/log.ts";

Log.info(`ops-mfe index boot - version=${appConfig.buildDate} [${appConfig.buildHash}]`);

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Root element not found');
}

const root = ReactDOM.createRoot(rootElement);

root.render(<App />);
